// extracted by mini-css-extract-plugin
export default {"storyDetail":"c-r_hg","storyDetail__photo":"c-r_hh"};